import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './primitives.css';

/**
 * Foundation primitive: Button（Phase D §4.3 / Phase B 凍結対象 API）
 *
 * 配色は primitives.css の mood トークン経由のみ。hex 直書きはしない。
 * - variant: primary=アクセント塗り / secondary=アクセント枠線 / ghost=透明
 * - size: sm / md / lg（typography トークンの text スケールに対応）
 * - disabled: 減光＋pointer 無効（CSS 側で pointer-events:none）
 * その他の button 属性（type, aria-* 等）は ...rest で透過する。
 */
export type ButtonVariant = 'primary' | 'secondary' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children?: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = ['mg-btn', `mg-btn--${variant}`, `mg-btn--${size}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
